module.exports = __webpack_public_path__ + "img/th.8351c3e3.png";